var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7079 27.7201C27.3213 28.3334 28.2679 27.3867 27.6546 26.7867L22.6546 21.7734C24.4085 19.8328 25.378 17.3092 25.3746 14.6934C25.3746 8.84008 20.6146 4.08008 14.7613 4.08008C8.90795 4.08008 4.14795 8.84008 4.14795 14.6934C4.14795 20.5467 8.90795 25.3067 14.7613 25.3067C17.4013 25.3067 19.8413 24.3334 21.7079 22.7201L26.7079 27.7201ZM5.47995 14.6934C5.47995 9.57341 9.65328 5.41341 14.7599 5.41341C19.8799 5.41341 24.0399 9.57341 24.0399 14.6934C24.0399 19.8134 19.8799 23.9734 14.7599 23.9734C9.65328 23.9734 5.47995 19.8134 5.47995 14.6934Z",
    fill: "#898A8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.224c7a534fe23363699290b009e25a5e.svg";
export { ForwardRef as ReactComponent };